import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_Organization } from './db-def.js';
export const ApiDef_Organization = {
    _v1: {
        getAllowedOrganizationIds: { method: HttpMethod.GET, path: `v1/${DBDef_Organization.dbKey}/get-allowed-ids` },
        deleteOrganization: { method: HttpMethod.POST, path: `v1/${DBDef_Organization.dbKey}/delete-organization` },
    }
};
//# sourceMappingURL=api-def.js.map